// Add your JS customizations here
document.addEventListener('DOMContentLoaded', function () {
	AOS.init({
		duration: 800,   // Animation duration in ms
	});

	history.scrollRestoration = 'manual';

	window.scrollTo(0, 0);

	const mainNav = document.querySelector('#main_nav');
	const mainNavToggler = document.querySelector('.navbar-toggler');
	const fixed_filter = document.querySelector('#fixed_filter');
	const countHeader = document.querySelector('#count_header');

	let countHeaderTop = 0;

	function updateCountHeaderPosition() {
	    if (countHeader) {
	        countHeaderTop = countHeader.getBoundingClientRect().top + window.scrollY;
	    }
	}

	function updateScrollState() {

	    if (mainNav) {
	        if (window.scrollY > 50) {
	            mainNav.classList.add('scrolled');
	            document.body.classList.add('scrolled');
	        } else {
	            mainNav.classList.remove('scrolled');
	            document.body.classList.remove('scrolled');
	        }
	    }

	    if (fixed_filter && countHeader && mainNav) {

	        const navHeight = mainNav.getBoundingClientRect().height;

	        if (window.scrollY >= countHeaderTop - navHeight) {
	            fixed_filter.style.top = `${navHeight}px`;
	        } else {
	            fixed_filter.style.top = '';
	        }
	    }
	}

	function refreshPosition() {
	    updateCountHeaderPosition();
	    updateScrollState();
	}

	window.addEventListener('scroll', updateScrollState);
	window.addEventListener('resize', refreshPosition);
	window.addEventListener('load', refreshPosition);

	refreshPosition();
	
	mainNavToggler.addEventListener('click', function () {
		document.body.classList.toggle('menu_open');
		mainNav.classList.toggle('menu_open');
	});

	const latest_businesses = document.querySelectorAll('#latest_businesses');

    latest_businesses.forEach(wrapper => {
        const splideEl = wrapper.querySelector('.splide');
        const prevBtn  = wrapper.querySelector('.business_prev');
        const nextBtn  = wrapper.querySelector('.business_next');

        const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
	    const perPage = 3;

	    const splide = new Splide(splideEl, {
	        type: slidesCount > perPage ? 'loop' : 'slide', // <-- only loop if enough slides
	        perPage: perPage,
	        perMove: 1,
	        arrows: false,
	        pagination: false,
	        breakpoints: {
	            575: { perPage: 1 },
	        },
	    });

	    splide.on('mounted', () => {
		    if (typeof AOS !== 'undefined') {
		        AOS.refreshHard();
		    }
		});

	    splide.mount();

        // External controls
        if (prevBtn) { prevBtn.addEventListener('click', () => splide.go('<')); }
        if (nextBtn) { nextBtn.addEventListener('click', () => splide.go('>')); }
    });

    const latest_events = document.querySelectorAll('#latest_events');

    latest_events.forEach(wrapper => {
        const splideEl = wrapper.querySelector('.splide');
        const prevBtn  = wrapper.querySelector('.event_prev');
        const nextBtn  = wrapper.querySelector('.event_next');

        const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
	    const perPage = 4;

	    const splide = new Splide(splideEl, {
	        type: slidesCount > perPage ? 'loop' : 'slide', // <-- only loop if enough slides
	        perPage: perPage,
	        perMove: 1,
	        arrows: false,
	        pagination: false,
	        breakpoints: {
	            575: { perPage: 1 },
	        },
	    });

	    splide.on('mounted', () => {
		    if (typeof AOS !== 'undefined') {
		        AOS.refreshHard();
		    }
		});

	    splide.mount();

        // External controls
        if (prevBtn) { prevBtn.addEventListener('click', () => splide.go('<')); }
        if (nextBtn) { nextBtn.addEventListener('click', () => splide.go('>')); }
    });

    const related_articles = document.querySelectorAll('#related_articles');

    related_articles.forEach(wrapper => {
        const splideEl = wrapper.querySelector('.splide');
        const prevBtn  = wrapper.querySelector('.article_prev');
        const nextBtn  = wrapper.querySelector('.article_next');

        const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
	    const perPage = 2;

	    const splide = new Splide(splideEl, {
	        type: slidesCount > perPage ? 'loop' : 'slide', // <-- only loop if enough slides
	        perPage: perPage,
	        perMove: 1,
	        arrows: false,
	        pagination: false,
	        breakpoints: {
	            575: { perPage: 1 },
	        },
	    });

	    splide.on('mounted', () => {
		    if (typeof AOS !== 'undefined') {
		        AOS.refreshHard();
		    }
		});

	    splide.mount();

        // External controls
        if (prevBtn) { prevBtn.addEventListener('click', () => splide.go('<')); }
        if (nextBtn) { nextBtn.addEventListener('click', () => splide.go('>')); }
    });

    const latest_offers = document.querySelectorAll('#latest_offers');

    latest_offers.forEach(wrapper => {
        const splideEl = wrapper.querySelector('.splide');
        const prevBtn  = wrapper.querySelector('.offer_prev');
        const nextBtn  = wrapper.querySelector('.offer_next');

        const slidesCount = splideEl.querySelectorAll('.splide__slide').length;
	    const perPage = 1;

	    const splide = new Splide(splideEl, {
	        type: slidesCount > perPage ? 'loop' : 'slide', // <-- only loop if enough slides
	        perPage: perPage,
	        perMove: 1,
	        direction: 'rtl',
	        arrows: false,
	        pagination: false,
	        breakpoints: {
	            575: { perPage: 1 },
	        },
	    });

	    splide.on('mounted', () => {
		    if (typeof AOS !== 'undefined') {
		        AOS.refreshHard();
		    }
		});

	    splide.mount();

        // External controls
        if (prevBtn) { prevBtn.addEventListener('click', () => splide.go('<')); }
        if (nextBtn) { nextBtn.addEventListener('click', () => splide.go('>')); }
    });

    const promo = document.getElementById("itl_promo");
	const promo_cta = document.getElementById("itl_promo_cta");
	const dismiss = document.getElementById("close_promo");

	if (promo) {

	  	// Check if session cookie exists
	  	const isDismissed = sessionStorage.getItem("promoDismissed") === "true";

	  	if (!isDismissed) {

	    	const onScroll = function () {
	      		const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
	      		const scrollTop = window.scrollY || document.documentElement.scrollTop;
	      		const scrollPercent = (scrollTop / scrollHeight) * 100;

	      		if (scrollPercent >= 20) {
	      			document.body.classList.add('promo_active');
	        		promo.classList.add("active");
	        		document.removeEventListener("scroll", onScroll);
	      		}	
	    	};

	    	document.addEventListener("scroll", onScroll);

	    	if (dismiss) {
	      		dismiss.addEventListener("click", function () {
	      			document.body.classList.remove("promo_active");
	    			promo.classList.remove("active");
	        		sessionStorage.setItem("promoDismissed", "true"); // mark as dismissed
	        		document.removeEventListener("scroll", onScroll);
	      		});
			}

			if (promo_cta) {
	      		promo_cta.addEventListener("click", function () {
	      			document.body.classList.remove("promo_active");
	    			promo.classList.remove("active");
	        		sessionStorage.setItem("promoDismissed", "true"); // mark as dismissed
	        		document.removeEventListener("scroll", onScroll);
	      		});
			}

	  	} else {
	    	// Already dismissed this session, hide promo
	    	document.body.classList.remove("promo_active");
	    	promo.classList.remove("active");
	  	}
	}

	


	
});
